/**
 *  Copyright (c) 2026 TechDivision GmbH
 *  All rights reserved
 *
 *  This product includes proprietary software developed at TechDivision GmbH, Germany
 *  For more information see https://www.techdivision.com/
 *
 *  To obtain a valid license for using this software please contact us at
 *  license@techdivision.com
 *
 */

/* theme.js
   Entry point for the modules that exist on every page – header, navigation and
   link handling. Included once via <script type="module"> in layout/theme.liquid.

   Section modules are NOT loaded from here. Each section renders a module script
   tag for its own JavaScript (snippets/module-script.liquid), so a visitor on a
   content page still never downloads the bundles of sections that are not on the
   page. Do not reintroduce a dynamic import() for that: Shopify minifies theme
   assets and rewrites import() to require(), which does not exist in the browser
   – the reasoning is documented in snippets/module-script.liquid. */

import { initHeaderSticky } from './header-sticky.js';
import { initMegaMenu } from './mega-menu-desktop.js';
import { initNavActive } from './nav-active.js';
import { initMobileMenu } from './mobile-menu-overlay.js';
import { initMobilePanels } from './mobile-menu-panels.js';
import { initLanguageDropdown } from './language-dropdown.js';
import { initExternalLinks } from './external-links.js';

function run(label, fn) {
  try {
    fn();
  } catch (e) {
    console.error(label + ' error:', e);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  run('Sticky Header', initHeaderSticky);
  run('Mega Menu', initMegaMenu);
  run('Nav Active', initNavActive);
  run('Mobile Menu', initMobileMenu);
  run('Sliding Panels', initMobilePanels);
  run('Language Dropdown', initLanguageDropdown);
  run('External Links', initExternalLinks);
});
